import { ethers } from 'ethers';
import RegistrarDeployment from '../../contracts/deployments/Registrar.json';
import { getState } from 'src/store';
import {
  ACTIVE_DEPLOYMENT,
  callContractTransaction,
  callContractView,
} from './common';

export const approveAllowance = async (
  allowance: number,
  tokenAddress: string,
): Promise<number> => {
  await callContractTransaction(
    'Token',
    'approve',
    [
      RegistrarDeployment[ACTIVE_DEPLOYMENT].address,
      ethers.parseEther(allowance.toString()),
    ],
    tokenAddress,
  );
  return checkAllowance(
    RegistrarDeployment[ACTIVE_DEPLOYMENT].address,
    tokenAddress,
  );
};

export const checkAllowance = async (
  spenderAddress: string,
  tokenAddress: string,
): Promise<number> => {
  const wallet = getState().wallet;
  const allowance = await callContractView(
    'Token',
    'allowance',
    [wallet?.address, spenderAddress],
    tokenAddress,
  );

  const allowanceInEther = ethers.formatEther(allowance);

  return Number(allowanceInEther);
};

export const balanceOf = async (tokenAddress: string): Promise<string> => {
  const wallet = getState().wallet;
  const balance = await callContractView(
    'Token',
    'balanceOf',
    [wallet?.address],
    tokenAddress,
  );
  return balance.toString();
};

export const mintToken = async (tokenAddress: string, amount: number) => {
  const wallet = getState().wallet;
  await callContractTransaction(
    'Token',
    'mint',
    [wallet?.address, ethers.parseEther(amount.toString())],
    tokenAddress,
  );
};
